import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-music-icon',
  templateUrl: './files-music.component.html'
})
export class FilesMusicComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
